<template>
  <div class="time_box">
    
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.time_box {
    width: 30%;
    height: 10%;
}
</style>